import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "TheFooterList footer-list" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (child, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "footer-list__item"
      }, [
        (child.currentApp)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "footer-list__item-link link-with-opacity",
              to: child.path
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(child.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : (child.path.startsWith('/'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "footer-list__item-link link-with-opacity",
                href: child.path
              }, [
                _createElementVNode("span", null, _toDisplayString(child.name), 1)
              ], 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "footer-list__item-link link-with-opacity",
                href: child.path,
                target: "_blank",
                rel: "noopener"
              }, [
                _createElementVNode("span", null, _toDisplayString(child.name), 1)
              ], 8, _hoisted_3))
      ]))
    }), 128))
  ]))
}